'use client'

import React from 'react'
import { useFormStatus } from 'react-dom'
import classNames from 'classnames'

export interface FieldsetProps {
    children: React.ReactNode
    className?: string
}

const Fieldset = (props: FieldsetProps): JSX.Element => {
    const { pending } = useFormStatus()

    const className = classNames(props.className)

    return <fieldset className={className} disabled={pending}>{props.children}</fieldset>
}

export default Fieldset
